import { Navigate, useLocation, useParams } from 'react-router-dom';
import { FeatureFlag } from 'types/features';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';
import { findReport, reportPath } from './reportCatalog';
import { REPORT_PAGES } from './reportPages';

/**
 * `/reports/:category/:reportKey`: the report's own page, or back to the all-reports page when there is no such report.
 * A link that names the report under another category or under its earlier key lands on the report's own path, with
 * its filters kept.
 */
export function ReportRoute() {
    const { category, reportKey } = useParams();
    const { search } = useLocation();
    const report = findReport(reportKey);
    // The route itself needs PORTAL_REPORTS, so a report without a flag of its own has nothing more to check.
    const isReportEnabled = useIsFeatureEnabled(report?.featureFlag ?? FeatureFlag.PORTAL_REPORTS);
    const Page = report ? REPORT_PAGES[report.key] : undefined;
    if (!report || !Page || !isReportEnabled) {
        return <Navigate to="/reports" replace />;
    }
    if (report.category !== category || report.key !== reportKey) {
        return <Navigate to={`${reportPath(report)}${search}`} replace />;
    }
    return <Page report={report} />;
}
